/* global angular */

(function() {
    "use strict";

    var app = angular.module('app');

    app.controller('RootCtrl', ['$scope', '$timeout', '$q', 'Utils', 'LocalStorage', 'SessionStorage', 'Account', 'Wishlist', 'api', 'CONFIG', 'gtm', function ($scope, $timeout, $q, Utils, local, session, Account, Wishlist, api, CONFIG, gtm) {

        var debug = false;

        var localMessages = {
            cookies: true,
        };

        var sessionMessages = {
            opening: true,
        };

        var messages;
        messages = session.get('messages');
        if (messages) {
            angular.extend(sessionMessages, messages);
        } else {
            sessionMessages = { opening: true };
            session.set('messages', sessionMessages);
        }

        messages = local.get('messages');
        if (messages) {
            angular.extend(localMessages, messages);
        } else {
            localMessages = { cookies: true };
            local.set('messages', localMessages);
        }

        function onGetLocalMessage() {
            var message = null;
            for (var p in localMessages) {
                if (!message && localMessages[p]) {
                    message = p;
                }
            }
            return message;
        }

        function onGetSessionMessage() {
            var message = null;
            for (var p in sessionMessages) {
                if (!message && sessionMessages[p]) {
                    message = p;
                }
            }
            return message;
        }

        function onDismissLocalMessage() {
            var message = onGetLocalMessage();
            if (message) {
                localMessages[message] = false;
            }
            if (!debug) {
                switch (message) {
                    case 'cookies':
                        localMessages.cookies = false;
                        local.set('messages', localMessages);
                        break;
                }
            }
        }

        function onDismissSessionMessage() {
            var message = onGetSessionMessage();
            if (message) {
                sessionMessages[message] = false;
            }
            if (!debug) {
                switch (message) {
                    case 'opening':
                        sessionMessages.opening = false;
                        session.set('messages', sessionMessages);
                        break;
                }
            }
        }

        function openCart() {
            $scope.$root.addModal('cartModal', null).then(function (data) {
            }, function (error) {
            });
        }

        function openUser() {
            $scope.$root.addModal('userModal', null).then(function (data) {
            }, function (error) {
            });
        }

        function doLogin() {
            $scope.$root.addModal('loginModal', null).then(function (data) {
            }, function (error) {
            });
        }
        
        function doLogout() {
            api.user.logout().then(function () {
                gtm.push({
                    event: 'Logout',
                    user: Account.user.id,
                    user_type: Account.user.profile
                });
                Account.setUser(null);                
                // FB.logout();
                location.href = CONFIG.app.pages.home;
            });
        }         

        function toggleWishlist(id) {            
            if (Account.isLogged()) {
                Wishlist.toggle(id);
            } else {
                doLogin();
            }
        }

        function printTraining(id,url) {            
            if (Account.isLogged()) {
                gtm.push({
                    event: 'Download allenamento',
                    user: Account.user.id,
                    user_type: Account.user.profile,
                    allenamento: id
                });
                // location.href = url;
                window.open(url, '_blank');
            } else {
                doLogin();
            }
        }

        function scrollTop() {
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, 500, 'swing', function () {
                // on end
            });
        }

        $scope.$on('loadUserModal', function () { openUser();})        
        $scope.$on('onAuthUserChange', function () {
            $scope.$root.modals[$scope.$root.modals.length - 1].reject();
        })   

        $scope.onDismissLocalMessage = onDismissLocalMessage;
        $scope.onDismissSessionMessage = onDismissSessionMessage;
        $scope.openCart = openCart;
        $scope.openUser = openUser;
        $scope.doLogin = doLogin;
        $scope.doLogout = doLogout;        
        $scope.toggleWishlist = toggleWishlist;
        $scope.printTraining = printTraining;
        $scope.config = CONFIG;
        $scope.account = Account;
        $scope.wishlist = Wishlist; 
        $scope.scrollTop = scrollTop;

        $timeout(function () {
            $scope.localMessages = localMessages;
            $scope.sessionMessages = sessionMessages;
        }, 2000);

        function keepAlive() {
            var minutes = 5;
            setTimeout(function () {
                Account.getUser(true).then(function (user) {
                    console.log('RootCtrl.keepAlive', user);
                    keepAlive();
                });
            }, 1000 * 60 * minutes);
        }

        $q.all([
            Account.getUser(true).then(function (user) {
                console.log('RootCtrl.user', user);
                if (Account.isLogged()) {
                    Wishlist.current();
                }
            })            
        ]).then(function (response) {
            keepAlive();

        }, function (error) {
            console.log('RootCtrl.error', error);
        });

    }]);

}());